'use client';

import { useSearchParams } from 'next/navigation';
import { useEffect } from 'react';

export function ProductListingCanonical({
  basePath,
  baseUrl,
}: {
  basePath: string;
  baseUrl: string;
}) {
  const searchParams = useSearchParams();
  const page = searchParams.get('page');

  useEffect(() => {
    // Only update canonical if we're on page 2 or higher
    if (page && page !== '1') {
      // Find existing canonical tag
      const existingCanonical = document.querySelector('link[rel="canonical"]');

      if (existingCanonical) {
        // Update existing canonical
        existingCanonical.setAttribute(
          'href',
          `${baseUrl}${basePath}?page=${page}`
        );
      } else {
        // Create new canonical if none exists (shouldn't happen with generateMetadata)
        const newCanonical = document.createElement('link');
        newCanonical.rel = 'canonical';
        newCanonical.href = `${baseUrl}${basePath}?page=${page}`;
        document.head.appendChild(newCanonical);
      }
    } else if (!page || page === '1') {
      // On page 1, ensure canonical is set to base path without query params
      const existingCanonical = document.querySelector('link[rel="canonical"]');
      if (existingCanonical) {
        existingCanonical.setAttribute('href', `${baseUrl}${basePath}`);
      }
    }

    // Cleanup function to reset canonical on unmount
    return () => {
      const existingCanonical = document.querySelector('link[rel="canonical"]');
      if (existingCanonical) {
        existingCanonical.setAttribute('href', `${baseUrl}${basePath}`);
      }
    };
  }, [page, basePath, baseUrl]);

  // Return null since we're managing the canonical tag via useEffect
  return null;
}
